import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import user from './modules/user';
import setting from './modules/setting';
import app from './modules/app';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        user,
        setting,
        app
    },
    getters
});

export default store;
